module.exports = __webpack_public_path__ + "static/img/product-18.a6b351b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-18.png
// module id = 4R0c
// module chunks = 0